//import liraries
import React, { useState, useEffect } from "react";
import {
  View,
  TouchableOpacity,
  Image,
  Dimensions,
  Linking,
} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { postHitBanner} from "../../api/serviceRequest";
import Loader from "../../common/Loader";
import * as RootNavigation from "../../utilities/RootNavigation";


const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const OfferCard = (props) => {
//   const offerList = props?.offerList || []
  const styles = useStyles();
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [offerList, setOfferList] = useState([])

  const onPressBanerCallApi = (item) => {
    const params = { bannerType: item.headLine };
    postHitBanner(params).then((res) => {
    });
  }

  const getOfferList = () => {
    // if(props?.offerList?.length){
    //   setOfferList(props?.offerList)
    
    //   setInterval(() => {
    //     setActiveIndex(prevCount => props?.offerList?.length - 1 == prevCount ? 0 : prevCount + 1);
    //   }, 13000); // execute every 13 second
    // }

    if (props?.offerList?.length) {
      setOfferList(props?.offerList);
 
      // Use a variable to store the interval for later cleanup
      const intervalId = setInterval(() => {
        setActiveIndex((prevCount) =>
          props?.offerList?.length - 1 == prevCount ? 0 : prevCount + 1
        );
      }, 12000); // execute every 15 seconds
 
      // Cleanup the interval when the component unmounts or when the offerList changes
      return () => clearInterval(intervalId);
    }

  }
  
  useEffect(() => {
    const cleanupInterval = getOfferList();
    // Cleanup function to clear the interval when the component unmounts or when the offerList changes
    return cleanupInterval;
  }, [props?.offerList]);
 


  return (
    <View style={styles.container}>
      {console.log(offerList,'offerList2')}
        <View style={styles.dashboard_advertisement}>
          {offerList.length > 0 ? (
            <TouchableOpacity
              onPress={() => {
                onPressBanerCallApi(offerList[activeIndex])
                if (offerList[activeIndex].headLine == 'Used Car Loan') {
                  // props.navigation.navigate("Home", { screen: "Other Services", })
                  RootNavigation.navigate("OtherServices/UsedCarLoan", { screen: "loan", })
                  global.activeScreen = "OtherServices"
                } else {
                  Linking.openURL(offerList[activeIndex].actionTxt);
                }
              }}
            >
              <Image
                source={
                  offerList[activeIndex]?.webPath
                    ? {
                      uri: `data:image/png;base64,${offerList[activeIndex]?.webPath}`,
                    }
                    : offerList[activeIndex]?.banner
                }
                style={{
                  maxWidth: 300,
                  width: 300,
                  minWidth: 300,
                  height: 372,
                  borderRadius: 13,
                  resizeMode: "cover",
                }}
              />
            </TouchableOpacity>
          ) : (
            <View style={{
              maxWidth: 300,
              width: 300,
              minWidth: 300,
              height: 372,
              borderRadius: 13,
            }} />
          )}
        </View>
      {loading && <Loader />}
    </View>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      height: 372.9,
      borderRadius: 12,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
      marginHorizontal: 10,
      alignItems: "center",
      flexGrow: 1,
      marginHorizontal: 10,
      overflow: "hidden",
    },
    
   
    
  },

  {
    [DEVICE_SIZES.XL]: {
      container: { maxWidth: 350 },
    },

    [DEVICE_SIZES.LG]: {
      container: { maxWidth: 270 },
    },

    [DEVICE_SIZES.MD]: {
      container: {
        height: 262,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginRight: 0,
        marginVertical: "3%",
        alignItems: "center",
      }
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: "100%",
        height: 227,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginVertical: "3%",
        alignItems: "center",
      }

    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: "100%",
        height: 301,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginRight: isTabView ? 0 : 10,
        marginVertical: "3%",
        alignItems: "center",
      },
     
    
    },
  }
);
//make this component available to the app
export default OfferCard;
